module.exports = __webpack_public_path__ + "static/media/caros-black.37eb6c7c.woff";